import { axiosInstance } from '../../../../../network/apis';
import { UserModel } from '../../../auth/models/UserModel';

export function getAllUsers({ params }: { params?: any }) {
  return axiosInstance.get<Array<UserModel>>(`/admin/users`, {
    params,
  });
}
